import { AbstractMesh, Color3, Material, PBRMaterial } from '@babylonjs/core';

import { Entity } from '../../ecs';

import { ZEDExtensionLoaderBase } from './ZEDExtensionLoaderBase';

import type { IAnimation, INode, IScene } from '@babylonjs/loaders/glTF/2.0';

export class StandardExtensionLoader extends ZEDExtensionLoaderBase<Entity> {
  static readonly INJECTABLE_TOKEN = Symbol.for('StandardExtensionLoader');

  public getLoaderName(): string {
    return 'Standard';
  }

  //------------------------------------------------------------------------------------
  // #### Initialize Babylon ####
  //------------------------------------------------------------------------------------
  public initializeMaterial(material: Material): void {
    if (material instanceof PBRMaterial) {
      material.albedoColor.r = Math.max(0, Math.min(material.albedoColor.r, 1));
      material.albedoColor.g = Math.max(0, Math.min(material.albedoColor.g, 1));
      material.albedoColor.b = Math.max(0, Math.min(material.albedoColor.b, 1));
      material.alphaCutOff = 0.5;
      material.maxSimultaneousLights = 0;
      material.ambientColor = Color3.White();
    }
  }

  //------------------------------------------------------------------------------------
  // #### Initialize Component ####
  //------------------------------------------------------------------------------------
  protected createEntity<T2 extends Omit<Entity, 'entityId'>>(
    entityId: string,
    components?: T2,
    extensionData?: any
  ): Entity | undefined {
    return {
      entityId: entityId,
      ...components,
    };
  }
  protected addComponentByScene(scene: IScene, extra: any, extensionData?: any): Entity[] | undefined {
    return undefined;
  }
  protected addComponentByNode(
    node: INode,
    animations?: IAnimation[] | undefined,
    extensionData?: any
  ): Entity[] | undefined {
    const transform = node._babylonTransformNode;
    const meshes = node._primitiveBabylonMeshes;
    if (meshes) {
      this.optimizeMeshes(meshes);
    }

    const extras = node.extras;
    if (extras && transform) {
      const entity = this.createEntity(
        transform.uniqueId.toString(),
        {
          TransformNode: transform,
        },
        extensionData
      );

      if (entity) return [entity];
    }

    return undefined;
  }

  //------------------------------------------------------------------------------------
  // #### ETC ####
  //------------------------------------------------------------------------------------
  protected optimizeMeshes(meshes: AbstractMesh[]) {
    for (const mesh of meshes) {
      // Pick 대상 제외 (raycast)
      mesh.isPickable = false;
      // 어떠한 경우에도 컬링하지 않고 활성화하는 지 여부
      mesh.alwaysSelectAsActiveMesh = false;
    }
  }
}
